var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.props.tag,_vm._b({tag:"component",class:['aspectratio', ("ratio-" + (_vm.props.ratio)), _vm.data.class, _vm.data.staticClass],style:(_vm.props.enableStyles ? _vm.data.style : ''),attrs:{"id":_vm.data.id}},'component',_vm.data.attrs,false),[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }